// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3cVMO","text":"SelectPayment_text__3kqdZ","title":"SelectPayment_title__1PfiX","btn":"SelectPayment_btn__2qWiU"};